/**
 * Module « Encours avant Vevidental » — sous-menu de la catégorie Finance.
 *
 * Il se déclare, le registre le découvre (import.meta.glob) : aucun fichier du
 * noyau n'est modifié, et le test d'invariants refuserait qu'on y écrive cette
 * route en dur.
 *
 * `navOrder` 55 le place juste après Finance (50) et avant Vevidental/Pennylane
 * — c'est un satellite de la file, pas un écran indépendant.
 *
 * Mêmes rôles que Finance : la page affiche des montants (§4.3).
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "encours-ancien",
  label: "Encours avant Vevidental",
  // `i-history` et non un « i-archive » qu'il aurait fallu ajouter au sprite :
  // un module ne doit modifier AUCUN fichier du noyau, sprite d'icônes compris.
  icon: "i-history",
  navGroup: "finance",
  navOrder: 55,
  rolesRequis: ["admin", "secretariat", "comptabilite"],
  routes: [{ path: "/encours-ancien", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
